import merge from 'lodash/merge';

class Category {
  constructor(data) {
    this.title = '';

    if (data) {
      merge(this, data);
    }
  }
}

export default Category;
